var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:assets' to update
import Asset from '../asset-internal';
function ExcelLogomark(_a) {
    var restProps = __rest(_a, []);
    return (_jsx(Asset, Object.assign({ viewBox: "0 0 40 40" }, restProps, { children: _jsx("path", { fill: "currentColor", d: "M22.242 4.762 4 8.026v23.901l18.231 3.31.001-3.05h12.626A1.15 1.15 0 0 0 36 31.037V8.939c0-.634-.511-1.148-1.142-1.148H22.241l.001-3.029zm-.001 4.078-.001 2.11h4.315v2.768h-4.316l-.001 1.056h4.317v2.768h-4.318v1.055h4.318v2.77h-4.319v1.05h4.319v2.77h-4.32l-.001 1.06h4.321v2.65h-4.322v2.23h12.713V8.84H22.241zm-5.832 5.758-2.611 5.4 2.682 5.43-2.425-.14-1.595-3.98-1.562 3.8-2.135-.12 2.507-4.99-2.382-5.043 2.311-.11 1.343 3.673 1.617-3.816 2.25-.104zm16.307 11.649h-5.113v2.64h5.113v-2.64zm0-3.829h-5.113v2.77h5.113v-2.77zm0-3.82h-5.113v2.77h5.113v-2.77zm0-3.823h-5.113v2.768h5.113v-2.768zm0-3.825h-5.113v2.768h5.113V10.95z", fillRule: "evenodd", clipRule: "evenodd" }) })));
}
export default ExcelLogomark;
